"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createInitAction = exports.Version = exports.AppMessageTypes = void 0;
var utils_1 = require("../utils");
var AppMessageTypes;
(function (AppMessageTypes) {
  AppMessageTypes["Init"] = "Init";
  AppMessageTypes["SignTransaction"] = "SignTransaction";
  AppMessageTypes["SignAllTransactions"] = "SignAllTransactions";
  AppMessageTypes["SignMessage"] = "SignMessage";
})(AppMessageTypes = exports.AppMessageTypes || (exports.AppMessageTypes = {}));
var Version;
(function (Version) {
  Version["V1"] = "V1";
})(Version = exports.Version || (exports.Version = {}));
var createInitAction = function createInitAction(_ref) {
  var _ref$persistent = _ref.persistent,
    persistent = _ref$persistent === void 0 ? true : _ref$persistent,
    additionalInfo = _ref.additionalInfo,
    application = _ref.application,
    description = _ref.description,
    network = _ref.network,
    icon = _ref.icon,
    persistentSessionId = _ref.persistentSessionId;
  var id = (0, utils_1.getRandomId)();
  return {
    type: AppMessageTypes.Init,
    persistent: persistent,
    application: application,
    description: description,
    additionalInfo: additionalInfo,
    network: network,
    icon: icon,
    version: Version.V1,
    id: id,
    persistentSessionId: persistentSessionId
  };
};
exports.createInitAction = createInitAction;